import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {BlockService} from '../../../service/BlockService';
import { Validation } from '../../../model/validation';
import {FormBuilder, FormGroup, Validators, FormControl} from "@angular/forms";
import * as moment from 'moment';
import { UserService } from '../../../service/UserService';
import { SessionService } from '../../../service/SessionService';
import {IS_PORTUGAL} from '../../../helpers/GlobalConstants';
@Component({
  selector: 'app-confirmaton-dialog',
  templateUrl: './reclamation-dialog.component.html',
  styleUrls: ['./reclamation-dialog.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ReclamationDialogComponent implements OnInit {
  user: any;
  dateShift: any;
  isUnlockFiche = false;
  reclamationForm: FormGroup;
  motifReclam: FormControl;
  errorMsg: string;
  isPorgugal:boolean;
  _send : boolean = false;
  constructor(public dialogRef: MatDialogRef<ReclamationDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private blockservice: BlockService,
              private sessionService: SessionService,
              private fb: FormBuilder,
              private userService:UserService) {
              this.motifReclam = new FormControl('');
  }

  ngOnInit() {
    this.user = this.data.user;
    this.dateShift = this.data.dateShift;
    this.isUnlockFiche = this.data.isUnlockFiche;
    this.isPorgugal  = localStorage.getItem(IS_PORTUGAL) == 'Y';



  }
  public CloseDialog() {
    this.dialogRef.close();
  }

  proceed(){
    this._send = true;
    if(!this.isUnlockFiche){
      this.Validation();
    }else {
      this.unlockFiche();
    }
  }

  public Validation() {
    this.userService.getHRBPOrDirectorManagers(this.user,this.isPorgugal).subscribe((res: any) => {
      this.blockservice.openFicheByUser(
        new Validation(this.data.blockIds, this.data.breakOverflowIds, this.dateShift, this.motifReclam.value, res.registrationNumber, this.user),
        () => {
          this.dialogRef.close(true);
          this._send = false;
        },
        (error) => this.errorMsg = JSON.stringify(error.error.message));
    },
    error => {
      this._send = false;
      this.errorMsg = error;
      }
    )

  }
  public unlockFiche() {
    this.userService.getHRBPOrDirectorManagers(this.user,this.isPorgugal).subscribe((res: any) => {
        this.blockservice.unlockFicheByUser(
          new Validation(this.data.blockIds, this.data.breakOverflowIds, this.dateShift, this.motifReclam.value, res.registrationNumber, this.user),
          () => {
            this.dialogRef.close(true);
            this._send = false;
          },
          (error) => this.errorMsg = JSON.stringify(error.error.message));
      },
      error => {
        this._send = false;
        this.errorMsg = error;
      }
    )

  }

  sendReclamation$$() {
    console.log('Sending reclamation', this.blockservice.currentUser, 2, 4);
    this.dialogRef.close();
  }
}




// WEBPACK FOOTER //
// ./src/app/view/block-temps/reclamation-dialog/reclamation-dialog.component.ts